export enum FEEDBACK_CAMPAIGN_TYPES {
  POPUP = 'POPUP',
  DIALOG = 'DIALOG',
  CARD = 'CARD',
  BANNER = 'BANNER',
}

export enum FEEDBACK_CAMPAIGN_ORIGINS {
  TYPEFORM = 'TYPEFORM',
  INTERNAL = 'INTERNAL',
}

export enum FEEDBACK_CAMPAIGN_DISPLAY_LOCATION {
  METEO = 'METEO',
  SUGGESTIONS = 'SUGGESTIONS',
  FEEDBACK = 'FEEDBACK',
  CREATE_FLASHCARDS_DECK = 'CREATE_FLASHCARDS_DECK',
  MOOD_TRACKER = 'MOOD_TRACKER',
  LESSON_EXERCISE = 'LESSON_EXERCISE',
}

export enum FEEDBACK_CAMPAIGN_TRIGGER_TYPES {
  AUTO = 'AUTO',
  CLICK = 'CLICK',
}

export const FEEDBACK_CAMPAIGN_ANSWER_COMMENT_MAX_LENGTH = 500;
export * from './model';
